import { render, staticRenderFns } from "./speaker-card.vue?vue&type=template&id=7bb7ea05&scoped=true"
import script from "./speaker-card.vue?vue&type=script&lang=js"
export * from "./speaker-card.vue?vue&type=script&lang=js"
import style0 from "./speaker-card.vue?vue&type=style&index=0&id=7bb7ea05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb7ea05",
  null
  
)

export default component.exports